export default __webpack_public_path__ + "static/0080-0ae0b4df5ca95eae02b1914e71e94898.png";